import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrInitialCausality } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';
import { ISelect } from '../../../../../../shared/types/shared';
import { InitialCausality } from '../../../../../../shared/types/typifications/initialCausality';

export const usePqrInitialCausality = (
    initialCausality?: PqrInitialCausality,
    initialCausalityCurrent?: InitialCausality
) => {
    const formik = useFormik({
        initialValues: {
            product: '',
            motive: '',
            submotive1: '',
            submotive2: '',
            submotive3: '',
            submotive4: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const data = initialCausality ?? initialCausalityCurrent;
        const motiveId = (data?.motive as ISelect)?.id;
        const sub1 = data?.submotive1 as ISelect | undefined;
        const sub2 = data?.submotive2 as ISelect | undefined;
        const sub3 = data?.submotive3 as ISelect | undefined;
        const sub4 = data?.submotive4 as ISelect | undefined;

        const submotive1 =
            sub1?.parent?.id && motiveId && sub1.parent.id === motiveId
                ? sub1
                : 'N/A';

        const submotive2 =
            submotive1 !== 'N/A' &&
            sub2?.parent?.id &&
            sub1?.id &&
            sub2.parent.id === sub1.id
                ? sub2
                : 'N/A';

        const submotive3 =
            submotive2 !== 'N/A' &&
            sub3?.parent?.id &&
            sub2?.id &&
            sub3.parent.id === sub2.id
                ? sub3
                : 'N/A';

        const submotive4 =
            submotive3 !== 'N/A' &&
            sub4?.parent?.id &&
            sub3?.id &&
            sub4.parent.id === sub3.id
                ? sub4
                : 'N/A';

        formik.setValues({
            product: useGetNameOrValue(
                ((data?.product as ISelect)?.name as string) || ''
            ),
            motive: useGetNameOrValue(
                ((data?.motive as ISelect)?.name as string) || ''
            ),
            submotive1: useGetNameOrValue(submotive1),
            submotive2: useGetNameOrValue(submotive2),
            submotive3: useGetNameOrValue(submotive3),
            submotive4: useGetNameOrValue(submotive4),
        });
    }, [initialCausality, initialCausalityCurrent]);

    return {
        formik,
    };
};
